import { createAction } from '../../store.model';
import { User } from '../../user/user.model';

import { InsightsSummaryDataKpi } from './model/insights-summary-data-kpi.model';
import { InsightsSummaryData } from './model/insights-summary-data.model';
import { KpiType } from './model/kpi-type.model';
import { ViewSummaryPeriodType } from './model/view-summary-period-type.model';

export enum ActionType {
    COACHING_INSIGHT__RELOAD = 'COACHING_INSIGHT__RELOAD',
    COACHING_INSIGHT__RELOAD_RESULT = 'COACHING_INSIGHT__RELOAD_RESULT',
    COACHING_INSIGHT__SELECT_PERIOD_TYPE = 'COACHING_INSIGHT__SELECT_PERIOD_TYPE',
    COACHING_INSIGHT__SELECT_KPI = 'COACHING_INSIGHT__SELECT_KPI',
    COACHING_INSIGHT__SELECT_USER = 'COACHING_INSIGHT__SELECT_USER',
    COACHING_INSIGHT__SELECT_USER_RESULT = 'COACHING_INSIGHT__SELECT_USER_RESULT',
    COACHING_INSIGHT__CLEAR_STATE = 'COACHING_INSIGHT__CLEAR_STATE',
}

export interface InitAction {
    userId: number;
    periodTypeId: number;
    periodDate: Date;
    kpiTypeId: KpiType;
}

export const reload = createAction<ActionType, InitAction>(
    ActionType.COACHING_INSIGHT__RELOAD,
);

export interface ReloadResultAction extends InitAction {
    insightSummaryData?: InsightsSummaryData;
}

export const reloadResult = createAction<ActionType, ReloadResultAction>(
    ActionType.COACHING_INSIGHT__RELOAD_RESULT,
);

/// //////////////////////

export interface SelectPeriodTypeAction {
    periodType: ViewSummaryPeriodType;
}

export const selectPeriodType = createAction<
    ActionType,
    SelectPeriodTypeAction
>(ActionType.COACHING_INSIGHT__SELECT_PERIOD_TYPE);

/// //////////////////////

export interface SelectKpiAction {
    kpi: InsightsSummaryDataKpi;
}

export const selectKpi = createAction<ActionType, SelectKpiAction>(
    ActionType.COACHING_INSIGHT__SELECT_KPI,
);

/// //////////////////////

export interface SelectUserAction {
    userId: number;
    authUserId: number;
}

export const selectUser = createAction<ActionType, SelectUserAction>(
    ActionType.COACHING_INSIGHT__SELECT_USER,
);

export interface SelectUserResultAction extends SelectUserAction {
    user?: User;
    userImage?: string;
}

export const selectUserResult = createAction<
    ActionType,
    SelectUserResultAction
>(ActionType.COACHING_INSIGHT__SELECT_USER_RESULT);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ClearStateAction {}

export const clearState = createAction<ActionType, ClearStateAction>(
    ActionType.COACHING_INSIGHT__CLEAR_STATE,
);
